/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_NetworkInputs */

const cs_api_error_network = /** @type {(inputs: Api_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se spojit se serverem. Zkontrolujte připojení a zkuste to znovu.`)
};

const en_api_error_network = /** @type {(inputs: Api_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach the server. Check your connection and try again.`)
};

/**
* | output |
* | --- |
* | "Could not reach the server. Check your connection and try again." |
*
* @param {Api_Error_NetworkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_network = /** @type {((inputs?: Api_Error_NetworkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_NetworkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_network(inputs)
	return cs_api_error_network(inputs)
});